import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheCrypt} from "../TheCrypt";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {Sprite} from "pixi.js";
import {TheCryptSymbol} from "../symbols/TheCryptSymbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TheCryptWinConfig} from "../configs/TheCryptWinConfig";

export class TheCryptHelper {

    public static isGameStarted: boolean = false;

    /**
     * Use this method to catch the position from the TransformWorld between two objects in two different containers/layers.
     * @param objToSet Uses the  PIXI.DisplayObject's container to remove the it's offset.
     * @param objToMimic PIXI.DisplayObject to copy the position from.
     * @param position — The world origin to calculate from.
     * @returns {PIXI.Point} Mimiced position.
     */
    public static copyLocalPosition(objToSet: PIXI.DisplayObject, objToMimic: PIXI.DisplayObject | undefined, position?: PIXI.Point | undefined): PIXI.Point {
        return <PIXI.Point>objToSet.parent.toLocal(objToSet.parent.position, objToMimic, position);
    }

    public static getBigWinLevel(): number {
        return 1;
    }

    public static isFreeSpin(mode: string): boolean {
        return mode.indexOf("FREESPIN") > -1;
    }

    public static checkIfSymbolIsNull(symbol: TheCryptSymbol): void {
        if (symbol == null) {
            debugger;
            throw new Error(`AvalancheReelPartAnimator.animateAllIn, symbol is null!`);
        }
    }

    public static isWildSymbol(symName: string): boolean {
        return symName === "W";
    }

    public static isCollectiveSymbol(symName: string): boolean {
        return (symName[0] === "M" || symName !== "M");
    }

    public static isLargerSymbol(symName: string): boolean {
        return (symName === "M" || symName === "W" || symName === "S" || symName.indexOf("FW") > -1);
    }

    public static isNormal(mode: string): boolean {
        return mode.indexOf("NORMAL") > -1;
    }

    public static isRespin(mode: string): boolean {
        return mode.indexOf("AVALANCHE") > -1;
    }

    public static isInvisibleSym(symName: string): boolean {
        return symName === "Y" || symName === "X";
    }

    public static isBigWin(win: number, playedBetValue: number): boolean {
        let winRatio: number = MathHelper.ceilToDecimals((win / playedBetValue), 2);
        return (winRatio >= TheCryptWinConfig.WIN_RATIOS.bigWin[0].ratio);
    }

    public static copyArray(arr: string[][]): string[][] {
        const temp: string[][] = [];
        arr.forEach((elements: string[]) => {
            const newElements: string[] = [];
            elements.forEach((element: string) => {
                newElements.push(element);
            });
            temp.push(newElements);
        });
        return temp;
    }

    public static get isIpad(): boolean {
        const resizeData: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            return (resizeData.width >= 955 && resizeData.width <= 965);
        } else {
            return (resizeData.height >= 955 && resizeData.height <= 965);
        }
    }

    public static getBuyFeaturePrice(): number {
        let betLevel = TheCrypt.apiPlugin.freeBets.hasFreeBets() ? TheCrypt.apiPlugin.freeBets.getBet() : TheCrypt.apiPlugin.betLevel.getLevel();
        let price: number = TheCrypt.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (TheCrypt.model.data.wasFeatureBuy || (TheCrypt.model.buyFeatureName === "BOOSTED_BET" && TheCrypt.model.boostedBet)) {
            for (let index = 0; index < TheCrypt.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheCrypt.model.initData.featureBuyTimesBetValue[index].name === TheCrypt.model.buyFeatureName) {
                    price *= TheCrypt.model.initData.featureBuyTimesBetValue[index].price;
                    price = MathHelper.roundToDecimals(price, 2);
                    break;
                }
            }
        }
        return price;
    }

    public static isWinBelowStake(): boolean {
        return TheCrypt.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (TheCrypt.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static createSprite(spriteName?: string, x: number = 0, y: number = 0): Sprite {
        const sprite: Sprite = new PIXI.Sprite(spriteName ? TheCrypt.assetLoader.getTextures(spriteName)[0] : PIXI.Texture.EMPTY);
        sprite.position.set(x, y);
        return sprite;
    }

    public static createDefaultSixBySixBooleanArray(): boolean[][] {
        return ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(6, () => false);
        });
    }

    public static randomBetween(min: number, max: number): number {
        return Math.floor(Math.random() * (1 + max - min) + min);
    }

    public static sum(arr: number[]): number {
        return arr.reduce((a, b) => a + b, 0);
    }

    public static resetSpineItem(item: PIXI.spine.Spine): void {
        item.skeleton.setSlotsToSetupPose();
        item.skeleton.setToSetupPose();
        item.state.clearTracks();
        item.state.setEmptyAnimation(0, 0);
    }

    public static getToggleType(): string {
        if (TheCrypt.model.currentWinRatio >= TheCryptWinConfig.WIN_RATIOS.normalWin[3].ratio) {
            return "";
        }

        if (TheCrypt.model.currentWinRatio >= TheCryptWinConfig.WIN_RATIOS.normalWin[2].ratio) {
            return "medium";
        }
        return "small";
    }
}